import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { useChatContext } from '../context/useChatContext.js';

function GlobalAdminRoute({ children }) {
  const { isSuperAdmin, isGlobalAdmin } = useChatContext();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (isSuperAdmin === null) {
    return (
      <div className="app-boot-loading">
        <div className="app-boot-loading__content">Carregando perfil...</div>
      </div>
    );
  }

  if (!isGlobalAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default GlobalAdminRoute;
